/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PagedResultDto_ParticipantBankVerificationDto } from '../models/PagedResultDto_ParticipantBankVerificationDto';
import type { Wealthlane_FinanceIntegrationService_Dtos_CommonDto_FileExportTemplate } from '../models/Wealthlane_FinanceIntegrationService_Dtos_CommonDto_FileExportTemplate';
import type { Wealthlane_FinanceIntegrationService_Dtos_CommonDto_IntStatusDropdownDto } from '../models/Wealthlane_FinanceIntegrationService_Dtos_CommonDto_IntStatusDropdownDto';
import type { Wealthlane_FinanceIntegrationService_Dtos_ParticipantBank_ExportParticipantBankVerificationDto } from '../models/Wealthlane_FinanceIntegrationService_Dtos_ParticipantBank_ExportParticipantBankVerificationDto';
import type { Wealthlane_FinanceIntegrationService_Dtos_ParticipantBank_ParticipantBankVerificationDto } from '../models/Wealthlane_FinanceIntegrationService_Dtos_ParticipantBank_ParticipantBankVerificationDto';
import type { Wealthlane_FinanceIntegrationService_Dtos_Response_ResponseDto } from '../models/Wealthlane_FinanceIntegrationService_Dtos_Response_ResponseDto';
import type { Wealthlane_Shared_Hosting_Dtos_GenericResponseDtos_GenericTaskResponseDto } from '../models/Wealthlane_Shared_Hosting_Dtos_GenericResponseDtos_GenericTaskResponseDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ParticipantBankJobService {

    /**
     * @returns Wealthlane_FinanceIntegrationService_Dtos_CommonDto_IntStatusDropdownDto OK
     * @throws ApiError
     */
    public static getApiFinanceIntegrationApiAppParticipantBankJobBankVerificationStatus(): CancelablePromise<Array<Wealthlane_FinanceIntegrationService_Dtos_CommonDto_IntStatusDropdownDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/finance-integration/api/app/participant-bank-job/bank-verification-status',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_FinanceIntegrationService_Dtos_CommonDto_FileExportTemplate OK
     * @throws ApiError
     */
    public static postApiFinanceIntegrationApiAppParticipantBankJobExportParticipantBankVerificationRequest(
requestBody?: Wealthlane_FinanceIntegrationService_Dtos_ParticipantBank_ExportParticipantBankVerificationDto,
): CancelablePromise<Wealthlane_FinanceIntegrationService_Dtos_CommonDto_FileExportTemplate> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/finance-integration/api/app/participant-bank-job/export-participant-bank-verification-request',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param formData 
     * @returns Wealthlane_FinanceIntegrationService_Dtos_Response_ResponseDto OK
     * @throws ApiError
     */
    public static postApiFinanceIntegrationApiAppParticipantBankJobParticipantBankVerificationRequest(
formData?: {
File?: Blob;
},
): CancelablePromise<Wealthlane_FinanceIntegrationService_Dtos_Response_ResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/finance-integration/api/app/participant-bank-job/participant-bank-verification-request',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_FinanceIntegrationService_Dtos_Response_ResponseDto OK
     * @throws ApiError
     */
    public static putApiFinanceIntegrationApiAppParticipantBankJobParticipantBankListForVerification(
requestBody?: Array<Wealthlane_FinanceIntegrationService_Dtos_ParticipantBank_ParticipantBankVerificationDto>,
): CancelablePromise<Wealthlane_FinanceIntegrationService_Dtos_Response_ResponseDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/finance-integration/api/app/participant-bank-job/participant-bank-list-for-verification',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param bankVerificationStatusId 
     * @param companyId 
     * @param filter 
     * @param sorting 
     * @param skipCount 
     * @param maxResultCount 
     * @returns PagedResultDto_ParticipantBankVerificationDto OK
     * @throws ApiError
     */
    public static getApiFinanceIntegrationApiAppParticipantBankJobParticipantBankListForVerification(
bankVerificationStatusId?: Array<number>,
companyId?: Array<string>,
filter?: string,
sorting?: string,
skipCount?: number,
maxResultCount?: number,
): CancelablePromise<PagedResultDto_ParticipantBankVerificationDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/finance-integration/api/app/participant-bank-job/participant-bank-list-for-verification',
            query: {
                'BankVerificationStatusId': bankVerificationStatusId,
                'CompanyId': companyId,
                'Filter': filter,
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param formData 
     * @returns Wealthlane_Shared_Hosting_Dtos_GenericResponseDtos_GenericTaskResponseDto OK
     * @throws ApiError
     */
    public static postApiFinanceIntegrationApiAppParticipantBankJobImportParticipantBankVerificationRequest(
formData?: {
File?: Blob;
},
): CancelablePromise<Wealthlane_Shared_Hosting_Dtos_GenericResponseDtos_GenericTaskResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/finance-integration/api/app/participant-bank-job/import-participant-bank-verification-request',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
